export default __webpack_public_path__ + "static/media/green.f91fb2cf.webp";